import React from 'react';
import { Box, Paper } from '@material-ui/core';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import formatHistoryMoney from '../../../utils/StringUtils/formatHistoryMoney';
import { useStyles } from './OrderHistoryFooter.styles';

function OrderHistoryFooter({
  driversTitle = 'Drivers',
  drivers,
  earnedTitle = 'Earned',
  earned,
  earningsStatus,
  completedOrders,
  missingCompensationCount,
}) {
  const classes = useStyles();

  return (
    <Paper className={classes.container} variant="outlined">
      <Box className={classes.content}>
        <Box className={classes.leftContainer}>
          <Box
            className={clsx(classes.metaContainer, classes.spacing)}
            data-testid="order-history-footer:drivers"
          >
            <Box className={classes.metaTitle}>{driversTitle}</Box>
            <Box className={classes.metaValue}>{drivers == null ? 'Unavailable' : drivers}</Box>
          </Box>
        </Box>
        {driversTitle === 'Drivers' && <Box className={classes.metaContainer}>
          <Box className={classes.metaTitle}>Orders</Box>
          <Box className={classes.metaValue}>{completedOrders == null ? 'Unavailable' : completedOrders}</Box>
        </Box>}
        <Box className={classes.rightContainer}>
          <Box
            className={classes.metaContainer}
            data-testid="order-history-footer:earned"
          >
            <Box className={classes.metaTitle}>{earningsStatus === 'incomplete' ? 'Known earnings' : earnedTitle}</Box>
            <Box className={classes.metaValue}>{formatHistoryMoney(earned)}</Box>
            {earningsStatus === 'incomplete' && missingCompensationCount != null &&
              <Box className={classes.metaTitle}>{missingCompensationCount} missing compensation</Box>}
          </Box>
        </Box>
      </Box>
    </Paper>
  );
}

OrderHistoryFooter.propTypes = {
  drivers: PropTypes.number,
  earned: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  earningsStatus: PropTypes.string,
};

export default OrderHistoryFooter;
